import { Button, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

const ExploreLink = ({ path }: { path: string }) => {
  const theme = useTheme();
  return (
    <Button
      component={Link}
      to={path}
      variant="outlined"
      fullWidth
      sx={{ 
        paddingY: "14px",
        color: theme.palette.common.black
      }}
    >
      Explore
    </Button>
  );
};

export default ExploreLink;